<template>
    <v-content>
        <v-container fluid>
            <v-layout wrap>
                <v-flex class="mb-4 d-flex align-items-center">
                    <div>
                        <h1 class="d-inline-block vertical-align-middle">{{ $t('my-requests') }}</h1>
                    </div>
                </v-flex>
                <v-flex xs12>
                    <v-card class="pa-2 pt-3 mb-3">
                        <v-form @submit.prevent="getRequests">
                            <v-layout wrap>
                                <v-flex md4 sm6 xs12 px-2 v-if=" 1 === 0 && $store.getters.user.source !== 4">
                                    <v-autocomplete :label="$t('user-name')"
                                                    v-model="filter.userId"
                                                    :items="usersList"
                                                    name="userId"
                                                    :item-text="'fullName'"
                                                    item-value="id"
                                                    clearable></v-autocomplete>
                                </v-flex>
                                <v-flex md4 sm6 xs12 px-2>
                                    <v-autocomplete :label="$t('process-ActionBar')"
                                                    v-model="filter.processId"
                                                    :items="processesList"
                                                    name="processId"
                                                    :item-text="getLabelByLang('processName', 'processName')"
                                                    item-value="processId"
                                                    clearable></v-autocomplete>
                                </v-flex>
                                <v-flex md4 px-2 sm6 xs12>
                                    <v-menu :close-on-content-click="false"
                                            :nudge-right="40"
                                            full-width
                                            lazy
                                            min-width="290px"
                                            offset-y
                                            ref="menu"
                                            transition="scale-transition"
                                            v-model="fromDateMenu">
                                        <v-text-field :data-vv-as="$t('from-date')"
                                                      :label="$t('from-date')"
                                                      clearable
                                                      name="fromDate"
                                                      prepend-icon="event"
                                                      readonly
                                                      slot="activator"
                                                      v-model="filter.fromDate"></v-text-field>
                                        <v-date-picker :max="filter.toDate ? filter.toDate : ''"
                                                       @change="fromDateMenu = false"
                                                       min="1900-01-01"
                                                       ref="picker"
                                                       v-model="filter.fromDate"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex md4 px-2 sm6 xs12>
                                    <v-menu :close-on-content-click="false"
                                            :nudge-right="40"
                                            full-width
                                            lazy
                                            min-width="290px"
                                            offset-y
                                            ref="menu"
                                            transition="scale-transition"
                                            v-model="toDateMenu">
                                        <v-text-field :data-vv-as="$t('to-date')"
                                                      :label="$t('to-date')"
                                                      clearable
                                                      name="toDate"
                                                      prepend-icon="event"
                                                      readonly
                                                      slot="activator"
                                                      v-model="filter.toDate"></v-text-field>
                                        <v-date-picker :min="filter.fromDate ? filter.fromDate : '1900-01-01'"
                                                       @change="toDateMenu = false"
                                                       ref="picker"
                                                       v-model="filter.toDate"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <!--<v-flex md4 sm6 xs12 px-2>
                                    <v-text-field :label="$t('serial-number')"
                                                  v-model="filter.serialNum"
                                                  v-validate="'max:50'"
                                                  :data-vv-as="$t('serial-number')"
                                                  :error-messages="errors.collect('serialNum')"
                                                  name="serialNum"></v-text-field>
                                </v-flex>-->

                                <v-flex md4 px-2 sm6 xs12>
                                    <v-text-field :data-vv-as="$t('beneficiary-nationalNumJOR')"
                                                  :label="$t('guestusername')"
                                                  class="mr-2"
                                                  name="beneficiaryNationalNumJOR"
                                                  v-model="filter.beneficiaryNationalNumJOR"></v-text-field>
                                </v-flex>

                                <v-flex md4 px-2 sm6 xs12>
                                    <v-text-field :data-vv-as="$t('full-name')"
                                                  :label="$t('full-name')"
                                                  class="mr-2"
                                                  name="fullName"
                                                  v-model="filter.fullName"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-btn color="primary" type="submit">{{ $t('filter') }}</v-btn>
                                    <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <v-data-table :loading="isLoading" hide-actions :headers="headers" :items="requestsList" class="elevation-1">
                        <template slot="items" slot-scope="props">
                            <tr :key="'myRequests' + props.index">
                                <td>{{ props.item.processName }}</td>
                                <td>{{ props.item.processStatusName }}</td>
                                <!--<td>{{ props.item.serialNum }}</td>-->
                                <td>{{ props.item.createdat | date }}</td>
                                <td>{{ props.item.beneficiarynationalnumjor }}</td>
                                <td>{{ props.item.fullname   }}</td>

                                <!--<td>
                                    <v-btn icon @click="goToRequest(props.index)">
                                        <v-icon>mdi-playlist-edit</v-icon>
                                    </v-btn>
                                </td>-->
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import ProcessInstanceService from '@/services/WorkFlow/ProcessInstanceService';
    import SecurityProcessService from "@/services/AdminSystem/Security/SecurityProcessService";
    import UserService from '@/services/UserService';
    export default {
        name: 'my-requests',
        data: () => ({
            isLoading: false,
            requestsList: [],
            usersList: [],
            processesList: [],
            filter: {},
            fromDateMenu: false,
            toDateMenu: false
        }),
        async created() {
            this.$store.dispatch('showLoading');
            await this.GetSecurityProcessByUserId();
            if (this.$store.getters.user.source !== 4) await this.getUsers();
            this.$store.dispatch('hideLoading');
            this.filterInit();
        },
        methods: {
            goToRequest(requestIndex) {
                if (this.$store.getters.user.source === 4) {
                    return;
                }
                const request = this.requestsList[requestIndex];
                if (!request.url) return;
                if (request.url.toLowerCase().includes('beneficiary'))
                    this.$router.push({
                        name: 'edit-beneficiary-by-request',
                        params: { from: '2', id: request.applicationID, processInstanceId: request.processInstanceId }
                    });
                else if (request.url.toLowerCase().includes('application'))
                    this.$router.push({
                        name: 'edit-application-form-by-request',
                        params: {
                            from: '2',
                            processInstanceId: request.processInstanceId,
                            id: request.applicationID
                        }
                    });
                else if (request.url.toLowerCase().includes('operat'))
                    this.$router.push({
                        name: 'edit-manage-operating-by-request',
                        params: {
                            from: '2',
                            processInstanceId: request.processInstanceId,
                            id: request.applicationID
                        }
                    });
                else if (request.url.toLowerCase().includes('social'))
                    this.$router.push({
                        name: 'edit-social-case-study-form-by-request',
                        params: {
                            from: '2',
                            processInstanceId: request.processInstanceId,
                            id: request.applicationID
                        }
                    });
                else if (request.url.toLowerCase().includes('installment'))
                    this.$router.push({
                        name: 'edit-installment-by-request',
                        params: {
                            from: '2',
                            processInstanceId: request.processInstanceId,
                            id: request.applicationID
                        }
                    });
                else if (request.url.toLowerCase().includes('tickting'))
                    this.$router.push({
                        name: 'edit-tickting-by-request',
                        params: {
                            from: '2',
                            processInstanceId: request.processInstanceId,
                            id: request.applicationID
                        }
                    });
            },
            async getRequests() {
                this.isLoading = true;
                const result = await ProcessInstanceService.getMyRequest(this.filter);
                if (result.data) this.requestsList = result.data;
                this.isLoading = false;
            },
            filterInit() {
                this.filter = {
                    keyword: '',
                    processId: 0,
                    userId: this.$store.getters.user.id,
                    serialNum: 0,
                    fromDate: '',
                    toDate: '',
                    beneficiaryNationalNumJOR: '',
                    fullName: '',
                };
                this.getRequests();
            },
            /* Get all SecurityProcess info */
            async GetSecurityProcessByUserId() {
                const body = {
                    roleID: 0,
                    processId: 0
                };
                this.processesList = (await SecurityProcessService.GetSecurityProcessByUserId(body)).data;
            },
            async getUsers() {
                this.usersList = (await UserService.getUsers()).data;
            }
        },
        computed: {
            headers() {
                return [
                    { text: this.$t('process-name'), value: 'process-ActionBar' },
                    { text: this.$t('process-status'), value: 'processStatusName' },
                    //{ text: this.$t('serial-number'), value: 'serialNum' },
                    { text: this.$t('request-date'), value: 'createdat' },
                    { text: this.$t('beneficiary-nationalNumJOR'), value: 'beneficiarynationalnumjor' },
                    { text: this.$t('full-name'), value: 'fullname' },
                    //{ text: this.$t('actionsDetails'), value: '', sortable: false }
                ];
            }
        }
    };
</script>

<style>
</style>